import React from 'react';
import { useLocation } from 'react-router';
import Footer from 'Components/Footer';
import Header from 'Components/Header';

import { DocumentPreviewSubLayout } from './sublayouts/DocumentPreviewSubLayout';

function DocumentPreviewWrapper() {
  const location = useLocation();

  return (
    <div className="main-layout">
      <Header location={location} />
      <DocumentPreviewSubLayout />
      <Footer />
    </div>
  );
}

export default DocumentPreviewWrapper;
